import React, {lazy} from "react";
import {Routes, Route} from "react-router-dom";
import Box from "@mui/material/Box";
import { CLUB_FIELDS_PATH, CLUB_FORMS_PATH, CLUB_TEAMS_PATH } from "../../routes";

const Teams = lazy(() => import("../Teams/Teams"));
const Fields = lazy(() => import("../Fields/Fields"));
const Forms = lazy(() => import("../Forms/Forms"));

export const Club = () => {
    return (
        <Box component="main" sx={{flexGrow: 1, p: 3}}>
            <Routes>
                <Route path={CLUB_TEAMS_PATH} element={<Teams/>}/>
                <Route path={CLUB_FIELDS_PATH} element={<Fields/>}/>
                <Route path={CLUB_FORMS_PATH} element={<Forms/>}/>
            </Routes>
        </Box>
    );
};

export default Club;
